<template>
    <div class="relative overflow-y-auto" style="max-height: calc(100vh - 600px)">
        <table v-if="accounts.length" class="table-auto w-full">
            <thead class="text-left sticky top-0 bg-white">
                <tr class="text-sm text-gray-500 opacity-90">
                    <th class="pl-2 font-normal">Apelido</th>
                    <th class="font-normal">Banco</th>
                    <th class="font-normal">Agência</th>
                    <th class="font-normal">Conta</th>
                    <th></th>
                </tr>
            </thead>
            <tbody class="text-sm">
                <tr
                    v-for="account in accounts"
                    class="cursor-pointer border-b hover:bg-gray-50"
                    :key="account.number"
                    @click="$emit('handle-click-item', account)"
                >
                    <td class="pl-2 py-5">{{ account.name || '--' }}</td>
                    <td class="py-5">{{ account.bank.name }}</td>
                    <td class="py-5">{{ account.agency }}</td>
                    <td class="py-5">{{ account.number }}</td>
                    <td class="py-5 text-right w-1/4">
                        <i
                            class="text-gray-400 fas fa-times p-2 cursor-pointer mr-3 hover:text-gray-600"
                            @click.stop="$emit('remove-item', account)"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <span v-show="!accounts.length" class="text-center block">Nenhuma conta disponível</span>
    </div>
</template>
<script>
export default {
    name: 'FavoredTable',
    props: {
        accounts: { type: Array, default: () => [] }
    }
}
</script>
